// angular import
import { Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';

import { ThemeConfig } from 'src/app/app-config';
import Swal from 'sweetalert2';
import { CompanyServiceService } from '../../../../../../modules/company/companylist/company-service.service';
import { ReportsComponent } from '../../../../../../modules/tools/reports/reports.component';
import { CommonService } from '../../../../../../shared/common.service';
import { NavigationItem } from '../../navigation';


@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss']
})
export class NavItemComponent implements OnInit {
  // public props
  @Input() item: NavigationItem;

  themeLayout: string;
  // constructor
  constructor(private location: Location, private sanitizer: DomSanitizer,public commonService: CommonService ,private companyService: CompanyServiceService, private route: Router ) {
    this.themeLayout = ThemeConfig.layout;
  }

  ngOnInit() {
   // debugger
    //this.commonService.getNotesData();
  }

  // public method
  closeOtherMenu(event: any) {
    debugger
    this.commonService.NotesName = event.currentTarget.text.toLowerCase().trim()
    //var NotesName = event.currentTarget.text.toLower().trim()
    if (this.commonService.NotesName.split('-')[0].trim().split('/')[2] > 0) {
      localStorage.setItem("Computations_Reports", "true");
      localStorage.removeItem('ComputationAPPeriodId');
      this.commonService.computationid = null;
    }
    else {
      localStorage.setItem("Computations_Reports", "false");
    }
    if (this.commonService.NotesName == 'statement compliance') {
      this.commonService.NotesName = 'Statement of Compliance'
    }
    if (this.commonService.NotesName == 'director remuneration') {
      this.commonService.NotesName = 'Directors remuneration'
    }
    if (this.commonService.NotesName == 'directors benefits') {
      this.commonService.NotesName = 'Directors’ benefits'
    }
    if (this.commonService.NotesName == 'off balance sheet') {
      this.commonService.NotesName = 'Off-Balance Sheet Arrangements'
    }
    if (this.commonService.NotesName == 'investment held as current assets') {
      this.commonService.NotesName = 'Investments held as current assets'
    }
    if (this.commonService.NotesName == 'loans and overdrawn bank') {
      this.commonService.NotesName = 'Loans and Overdrawn bank account balances'
    }
    if (this.commonService.NotesName == 'inventories') {
      this.commonService.NotesName = 'Inventories (Stock)'
    }
    if (this.commonService.NotesName == 'reserves retained profit') {
      this.commonService.NotesName = 'Reserves / Retained profit'
    }
    if (event.target.innerText == 'iXBRL_Computations_Reports') {
      localStorage.setItem("Computations_Reports", "true");
    }
    if (event.target.innerText == 'Accounts') {
      localStorage.setItem("Acounts", "true");
      localStorage.setItem("detail", "false");
      localStorage.setItem("transactions_report", "false");
      localStorage.setItem("trial_balance_report", "false");
    }
    if (event.target.innerText == 'Detailed Profit & Loss Report') {
      localStorage.setItem("Acounts", "false");
      localStorage.setItem("detailed", "true");
      localStorage.setItem("detail", "true");
      localStorage.setItem("transactions_report", "false");
      localStorage.setItem("trial_balance_report", "false");
    }
    else {
      localStorage.setItem("detail", "false");
    }
    if (event.target.innerText == 'Trial Balance Report') {
      localStorage.setItem("transactions_report", "false");
      localStorage.setItem("trial_balance_report", "true");
      localStorage.setItem("detail", "false");

    }
    if (event.target.innerText == 'Transactions Report') {
      localStorage.setItem("trial_balance_report", "false");
      localStorage.setItem("transactions_report", "true");
      localStorage.setItem("detail", "false");

    }

    else if (event.target.innerText == 'Business') {
      this.commonService.Isnavdata(0)
    }
    else if (event.target.innerText != 'Information' && event.target.innerText != 'Computations' && event.target.innerText != 'Trial Balance Report' && event.target.innerText != 'Transactions Report' ) {
      this.commonService.Isnavdata(2)
    }
    this.commonService.innertext = event.target.innerText;
    if (this.commonService.NotesName == "tax adviser" || this.commonService.NotesName == "user management" || this.commonService.NotesName == "fbi receipt" ) {
      this.commonService.Isnavdata(null)
    }
    if (this.commonService.NotesName == 'business' || this.commonService.AccountTemplateId == null ) {
      this.commonService.routeToCompanyList = false
      this.commonService.Isnavdata(0)
    }
   
    if (ThemeConfig.layout === 'vertical') {
      const ele = event.target as HTMLElement;
      if (ele !== null && ele !== undefined) {
        const parent = ele.parentElement as HTMLElement;
        const up_parent = ((parent.parentElement as HTMLElement).parentElement as HTMLElement).parentElement as HTMLElement;
        const last_parent = up_parent.parentElement;
        const sections = document.querySelectorAll('.pcoded-hasmenu');
        for (let i = 0; i < sections.length; i++) {
          //sections[i].classList.remove('active');
          if (this.commonService.NotesList?.filter(x => x.NotesDescription?.toLowerCase() == this.commonService.NotesName.toLowerCase())?.length == 0 && (this.commonService.NotesName != "accounts") && (this.commonService.NotesName != "previous period accounts data") && (this.commonService.NotesName != "computations") && (localStorage.getItem("Computations_Reports")!="true"))
          sections[i].classList.remove('pcoded-trigger');
        }

        if (parent.classList.contains('pcoded-hasmenu')) {
          parent.classList.add('pcoded-trigger');
          parent.classList.add('active');
        } else if (up_parent.classList.contains('pcoded-hasmenu')) {
          up_parent.classList.add('pcoded-trigger');
          up_parent.classList.add('active');
        } else if (last_parent.classList.contains('pcoded-hasmenu')) {
          last_parent.classList.add('pcoded-trigger');
          last_parent.classList.add('active');
        }
      }
      if (document.querySelector('app-navigation.pcoded-navbar').classList.contains('mob-open')) {
        document.querySelector('app-navigation.pcoded-navbar').classList.remove('mob-open');
      }
    } else {
      setTimeout(() => {
        const sections = document.querySelectorAll('.pcoded-hasmenu');
        for (let i = 0; i < sections.length; i++) {
          sections[i].classList.remove('active');
          sections[i].classList.remove('pcoded-trigger');
        }

        let current_url = this.location.path();
        if (this.location['_baseHref']) {
          current_url = this.location['_baseHref'] + this.location.path();
        }
        const link = "a.nav-link[ href='" + current_url + "' ]";
        const ele = document.querySelector(link);
        if (ele !== null && ele !== undefined) {
          const parent = ele.parentElement;
          const up_parent = parent.parentElement.parentElement;
          const last_parent = up_parent.parentElement;
          if (parent.classList.contains('pcoded-hasmenu')) {
            parent.classList.add('active');
          } else if (up_parent.classList.contains('pcoded-hasmenu')) {
            up_parent.classList.add('active');
          } else if (last_parent.classList.contains('pcoded-hasmenu')) {
            last_parent.classList.add('active');
          }
        }
      }, 500);
    }
  }

  clear(Url,target) {
    debugger
    if (Url == '/clear') {
      const sections = document.querySelectorAll('.pcoded-hasmenu');
      for (let i = 0; i < sections.length; i++) {
        sections[i].classList.remove('active');
        sections[i].classList.remove('pcoded-trigger');
      }
      this.commonService.setClearAllFields(true)
    } else if (Url == '/showbubble') {
    }
    else if (Url == '/fbireceipt') {
      if (target == 'FBI Receipt') {
        if (localStorage.getItem("companyId")) {
          var id = CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8)
          if (id != null && id != '') {
            this.companyService.getAllAccPeriod(id).subscribe((data: any) => {
              var Submissionrec = data.filter(x => x.APSubmissionStatus != null)
              if (Submissionrec.length > 0 && data.length > 0) {
                localStorage.setItem('APPeriodId', CryptoJS.AES.encrypt(Submissionrec[0].APPeriodID.toString(), "APS").toString())
                this.route.navigate(['/fbireceipt'])
              }
              else {
                //this.commonService.routeToCompanyList = false;
                //this.commonService.Isnavdata(0)
                this.route.navigate([this.route.url])
                Swal.fire('Andica Accounts Production', 'You have not filed this accounting period returns yet.', 'warning')
              }
            })
          }
          //else {
          //  Swal.fire('', 'There is no business or accounting period opened to view FBI receipt.Open the accounting period for which you want to view FBI receipt and then run the FBI receipt.', 'warning')
          //}
        }
        //else {
        //  Swal.fire('Andica Accounts Production', 'There is no Company or accounting period opened to view FBI receipt.Open the accounting period for which you want to view FBI receipt and then run the FBI receipt.', 'warning')
        //}
      } else {
        this.commonService.setLoadBusiness(true)
      }
      //if (localStorage.getItem("companyId")) {
      //  var id = CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8)
      //  if (id != null && id != '') {
      //    this.companyService.getAllAccPeriod(id).subscribe((data: any) => {
      //      var Submissionrec = data.filter(x => x.APSubmissionStatus != null)
      //      if (Submissionrec.length > 0 && data.length > 0) {
      //        localStorage.setItem('APPeriodId', CryptoJS.AES.encrypt(Submissionrec[0].APPeriodID.toString(), "APS").toString())
      //      this.route.navigate(['/fbireceipt'])
      //      }
      //      else {
      //        Swal.fire('Andica Accounts Production', 'You have not filled the Accounting Period Return Yet.', 'info')
      //      }
      //    })
      //  }
      //else {
      //  Swal.fire('', 'There is no Company or accounting period opened to view FBI receipt.Open the accounting period for which you want to view FBI receipt and then run the FBI receipt.', 'warning')
      //}
      //}
      //else {
      //  Swal.fire('Andica Accounts Production', 'There is no Company or accounting period opened to view FBI receipt.Open the accounting period for which you want to view FBI receipt and then run the FBI receipt.', 'warning')
      //}

    }
    else if (Url == '/reports/trailbalance') {
      //this.route.navigate(['/reports/trailbalance'])
    }
    else if (target == 'transactions report') {

    }
    //}
    else if (Url == '/business') {
      this.commonService.Isnavdata(5);

    }
    else {
      var x = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId1"), "APS").toString(CryptoJS.enc.Utf8)
      localStorage.setItem('APPeriodId', CryptoJS.AES.encrypt(x.toString(), "APS").toString())
    }
  }
 
  checked() {
    debugger
    if ($('#checkbox').is(':checked')) {
      $("#checkbox").prop("checked", true);
      //localStorage.setItem('showbubblechecked',"true")
      this.commonService.setShowBubble(true)
      var formdata = new FormData();
      formdata.append("APPeriodID", CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8))
      formdata.append("showbubble", "true")
      this.commonService.insertshowbubble(formdata)
      
    }
    else{
      $("#checkbox").prop("checked", false);
      //localStorage.setItem('showbubblechecked', "false")
      this.commonService.setShowBubble(false)
      var formdata = new FormData();
      formdata.append("APPeriodID", CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8))
      formdata.append("showbubble", "false")
      this.commonService.insertshowbubble(formdata)
      
    }
  }
  
}
